import { ChainedSchema } from '../general/ChainedSchema';
class SerializrType_resetToInitial extends ChainedSchema {
    deserializer(context) {
        context.json_overwrite = context.oldValue;
        return this.parentSchema.deserializer(context);
    }
}
export function resetToInitial(propSchema) {
    return new SerializrType_resetToInitial(propSchema);
}
